import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch, InjectReactive } from "vue-property-decorator";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";
import questionSettingTemplate from "./questionSettingTemplate.vue";
import { choice } from "@modules/newCommunity/pages/operationTools/pages/questionnaireEdit/validateUtils/newIndex";
import draggable from "vuedraggable";
import PicUpload from "@/components/picUpload/index.vue";
import EditSortDialog from "@/modules/newCommunity/pages/operationTools/pages/questionnaire/components/EditSortDialog.vue";
import { getCatalog, EnumCommunityType } from "@modules/newCommunity/pages/operationTools/api/questionnaire";
import { randomNumber } from "@/utils/commonUtil";
import { service } from "@modules/newCommunity/setup";
let diagnosis = class diagnosis extends Vue {
  constructor() {
    super(...arguments);
    this.drag = false;
    this.loading = false;
    this.catalogList = [];
    this.editSortDialogKey = Math.random();
    this.postForm = {
      title: "请选择以下选项",
      required: "1",
      itemScore: 0,
      optionContentType: "TEXT",
      correctAnswer: ["1"],
      optionsList: [{
        value: "选项1",
        content: "选项1",
        rightOption: true,
        otherInput: false,
        jsonConfig: {
          exclusive: false
        }
      }, {
        value: "选项2",
        content: "选项2",
        rightOption: true,
        otherInput: false,
        jsonConfig: {
          exclusive: false
        }
      }],
      catalogIds: [],
      whetherJoinQuestionBank: false,
      scoreRule: "",
      jsonConfig: {
        showIndex: true,
        otherInputForm: "NONE",
        otherInputNumberMin: null,
        otherInputNumberMax: null,
        otherInputNumberPrecision: null,
        otherInputMin: null,
        otherInputMax: null,
        selectRangeMin: null,
        selectRangeMax: null,
        fillInMin: null,
        fillInMax: null
      }
    };
    this.optionValidator = choice.content;
    this.rules = {
      title: [{
        required: true,
        message: "请输入标题",
        type: "string",
        trigger: "blur"
      }],
      required: [{
        required: true,
        message: "请选择是否必填",
        trigger: "blur"
      }],
      itemScore: [{
        required: true,
        message: "请填写题目分值",
        trigger: "blur"
      }],
      scoreRule: [{
        trigger: "blur",
        validator: this.validatorScoreRule
      }],
      optionsList: [{
        required: true,
        type: "array",
        validator: choice.optionsList
      }],
      // catalogIds: [{ required: true, type: "array", message: "请选择分类名", trigger: "blur" }],
      whetherJoinQuestionBank: [{
        required: true,
        message: "请选择是否加入题库",
        trigger: "blur"
      }],
      "jsonConfig.selectRangeMin": [{
        validator: this.validatorSelectRange
      }],
      otherInputForm: [{
        required: true,
        message: "请选择是否必填",
        trigger: "blur"
      }],
      "jsonConfig.fillInMin": [{
        validator: this.validatorfillIn
      }]
    };
    this.ICD10_Options = [];
    this.selectLoading = false;
    this.selectObj = {
      pageNum: 1
    };
    this.totalPage = 0;
  }
  watchPropData() {
    if (JSON.stringify(this.value) != JSON.stringify(this.postForm)) {
      this.postForm = JSON.parse(JSON.stringify(this.value));
      console.warn("postForm", this.postForm);
      this.clearValidate();
      this.$nextTick(() => {
        this.validate();
      });
    }
  }
  validatorScoreRule(rule, value, callback) {
    if (this.postForm.scoreRule != "UPLOAD") {
      if (this.postForm.optionsList.filter(op => {
        return op.rightOption;
      }).length == 0) {
        return callback(new Error("请至少选择一个正确答案"));
      }
    }
    callback();
  }
  validatorSelectRange(rule, value, callback) {
    if (this.postForm.jsonConfig.selectRangeMax && this.questionnaireType == "ANSWER" && this.postForm.scoreRule == "SAME") {
      if (this.postForm.optionsList.filter(op => {
        return op.rightOption;
      }).length > this.postForm.jsonConfig.selectRangeMax) {
        return callback(new Error("最多可选项数不能小于正确答案项数"));
      }
    }
    if (this.postForm.jsonConfig.selectRangeMax && this.postForm.jsonConfig.selectRangeMin && this.postForm.jsonConfig.selectRangeMin > this.postForm.jsonConfig.selectRangeMax) {
      callback(new Error("最多应大于最少"));
    } else {
      callback();
    }
  }
  validatorfillIn(rule, value, callback) {
    if (this.postForm.jsonConfig.fillInMax && value) {
      if (value > this.postForm.jsonConfig.fillInMax) callback(new Error("最多应大于最少"));else callback();
    } else callback();
  }
  get haveOtherSet() {
    return this.postForm.optionsList.some(ot => {
      return ot.otherInput;
    });
  }
  get questionnaireType() {
    return QuestionnaireEditModule.questionnaireType;
  }
  get communityType() {
    return this.$route.path.includes("newCommunity") ? EnumCommunityType.DOCTOR : EnumCommunityType.PATIENT;
  }
  get basicParams() {
    return {
      businessType: this.questionnaireType,
      communityType: this.communityType
    };
  }
  watchPostForm() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
  handleAttrValueFilter(val) {
    if (!this.selectLoading) {
      this.selectObj.labelName = val;
      this.selectObj.pageNum = 1;
      this.findDiseaseList();
    }
    // this.$nextTick(() => {
    //   (this.$refs.diseaseSelect as any).$el.children[2].children[0].children[0].scrollTop = 0;
    // });
  }
  handleLoadmore() {
    if (!this.selectLoading && this.selectObj.pageNum < this.totalPage) {
      this.selectObj.pageNum++;
      this.findDiseaseList();
    }
  }
  // 疾病列表
  findDiseaseList() {
    this.selectLoading = true;
    service.questionnaireDiseaseLabelPage(this.selectObj).then(res => {
      if (res.code === 200) {
        const newArr = res.data.rows;
        this.$nextTick(() => {
          const selectedArr = this.postForm.optionsList.map(item => item.content);
          newArr.forEach(item => {
            if (selectedArr.includes(item.labelName)) item.disabled = true;
          });
          console.log(newArr, selectedArr);
          // this.catalogOfDiseaseList = res.data.filter((item) => item.labelType == "ICD10");
          if (this.selectObj.pageNum !== 1) {
            this.ICD10_Options.push(...newArr);
          } else {
            this.ICD10_Options = newArr;
          }
          this.totalPage = res.data.totalPage;
          this.selectLoading = false;
        });
      }
    }).finally(() => {
      this.selectLoading = false;
    });
  }
  created() {
    // this.findDiseaseList();
    // this.initICD10_Options();
  }
  // initICD10_Options() {
  //   service.questionnaireDiseaseLabelPage().then((res: any) => {
  //     console.log(res);
  //   });
  // }
  emitChange() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
  removeOption(item, index) {
    // let findIndex = this.postForm.correctAnswer.findIndex((answer: string) => {
    //   return answer == item.value;
    // });
    // if (findIndex >= 0) {
    //   this.postForm.correctAnswer.splice(findIndex, 1);
    // }
    this.postForm.optionsList.splice(index, 1);
    this.emitChange();
  }
  optionContentTypeChange() {
    // this.postForm.optionsList.forEach((item: any) => {
    //   item.content = "";
    //   item.otherInput = false;
    // });
    return;
  }
  addOption(otherInput) {
    // const str = this.postForm.optionContentType == "TEXT" ? "选项" + (this.postForm.optionsList.length + 1) : "";
    const str = "";
    this.postForm.optionsList.push({
      value: str,
      content: otherInput ? "其它" : str,
      rightOption: false,
      otherInput: otherInput,
      jsonConfig: {
        exclusive: false
      },
      id: Number("1" + (randomNumber(6) + "")) * -1
    });
    this.emitChange();
  }
  getFormInstance() {
    return this.$refs.postForm;
  }
  validateOptions() {
    this.getFormInstance().validateField("optionsList");
  }
  resetFields() {
    this.getFormInstance().resetFields();
  }
  clearValidate() {
    if (this.getFormInstance()) {
      this.getFormInstance().clearValidate();
    }
  }
  remoteMethod(query) {
    this.loading = true;
    getCatalog({
      ...this.basicParams,
      name: query,
      pageSize: 50,
      pageNum: 1
    }).then(res => {
      this.catalogList = res.rows || [];
    }).finally(() => this.loading = false);
  }
  catalogFocus() {
    if (this.catalogList.length === 0) {
      this.remoteMethod();
    }
  }
  openSortDialog() {
    this.$refs.editSortDialog.onShow({
      isBusinessTypeDisable: true,
      formData: {
        businessType: this.questionnaireType
      }
    });
  }
  itemScoreCount() {
    if (this.postForm.scoreRule == "UPLOAD") {
      let max = 0;
      let scoreList = this.postForm.optionsList.map(op => {
        return op.jsonConfig.itemScore;
      });
      scoreList.sort((a, b) => {
        return b - a;
      });
      let maxSelectedNumber = this.postForm.jsonConfig.selectRangeMax || this.postForm.optionsList.length;
      scoreList.forEach((score, index) => {
        if (index < maxSelectedNumber) {
          max += score;
        }
      });
      this.postForm.itemScore = max;
    }
    if (this.postForm.scoreRule == "INCLUDE") {
      let max = 0;
      let rightOptionList = this.postForm.optionsList.filter(op => {
        return op.rightOption;
      });
      let scoreList = rightOptionList.map(op => {
        return op.jsonConfig.itemScore;
      });
      scoreList.sort((a, b) => {
        return b - a;
      });
      let maxSelectedNumber = this.postForm.jsonConfig.selectRangeMax || this.postForm.optionsList.length;
      scoreList.forEach((score, index) => {
        if (index < maxSelectedNumber) {
          max += score;
        }
      });
      this.postForm.itemScore = max;
    }
  }
  async validate() {
    let result = await this.getFormInstance().validate().catch(err => {
      return err;
    });
    if (result) {
      this.itemScoreCount();
    }
    return result;
  }
  // $ 开始拖拽
  onStart() {
    this.drag = true;
  }
  // $ 结束拖拽
  onEnd() {
    this.drag = false;
    this.emitChange();
  }
};
__decorate([InjectReactive()], diagnosis.prototype, "templateMode", void 0);
__decorate([Prop({
  type: Object,
  default() {
    return {};
  }
})], diagnosis.prototype, "value", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], diagnosis.prototype, "disabled", void 0);
__decorate([Watch("value", {
  deep: true,
  immediate: true
})], diagnosis.prototype, "watchPropData", null);
__decorate([Watch("postForm", {
  deep: true
})], diagnosis.prototype, "watchPostForm", null);
diagnosis = __decorate([Component({
  name: "diagnosis",
  components: {
    PicUpload,
    questionSettingTemplate,
    draggable,
    EditSortDialog
  },
  directives: {
    "el-select-loadmore": {
      bind(el, binding) {
        const SELECTWRAP_DOM = el.querySelector(".el-select-dropdown .el-select-dropdown__wrap");
        SELECTWRAP_DOM.addEventListener("scroll", function () {
          const condition = SELECTWRAP_DOM.scrollHeight - SELECTWRAP_DOM.scrollTop - 15 <= SELECTWRAP_DOM.clientHeight;
          if (condition) {
            binding.value();
          }
        });
      }
    }
  }
})], diagnosis);
export default diagnosis;